import React, { useEffect, useState } from 'react'
import { cn } from "@artprov/design-system";

const IMG_FILE_TYPES = ["image/png", "image/jpeg", "image/jpg"]
const PDFs_TYPE = ["application/pdf"]

export default function HtmlViewer({ file = {}, mensajeError = "Error al encontrar el archivo" }) {

    function getBase64ToFIle(file) {
        const mime = file.contentType;
        const content = file.content;
        let base64 = `data:${mime};base64,${content}`;
        return base64;
    }

    function getCorrectElement(file) {
        if (!file.contentType)
            return <p>{mensajeError}</p>
        if (IMG_FILE_TYPES.includes(file.contentType))
            return (
                <img
                    className={cn("w-full")}
                    src={getBase64ToFIle(file)}
                    alt={file?.name ?? "n/a"}
                />
            );
        if (PDFs_TYPE.includes(file.contentType))
            return (
                <iframe
                    width={420}
                    height={540}
                    src={getBase64ToFIle(file)}
                    title={file?.name ?? "n/a"}>
                </iframe>
            );
    }

    if (!file)
        return <p>{mensajeError}</p>

    return getCorrectElement(file)
}